// extracted by mini-css-extract-plugin
export var active = "_2n-d";
export var blink = "_2n-e";
export var container = "_2n-5";
export var controls = "_2n-0";
export var controlsRight = "_2n-1";
export var fakeCursor = "_2n-c";
export var hidden = "_2n-b";
export var quillContainerSmall = "_2n-7";
export var quillEditor = "_2n-6";
export var quillEditorSmall = "_2n-8";
export var quillFormatButtons = "_2n-a";
export var quillToolbar = "_2n-9";
export var removePadding = "_2n-2";
export var state = "_2n-3";
export var stateTitle = "_2n-4";